/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthResponse } from '../models/AuthResponse';
import type { CompleteProfileDto } from '../models/CompleteProfileDto';
import type { CompleteProfileResponse } from '../models/CompleteProfileResponse';
import type { CreateProfileDto } from '../models/CreateProfileDto';
import type { FirebaseTokenDto } from '../models/FirebaseTokenDto';
import type { RefreshTokenDto } from '../models/RefreshTokenDto';
import type { SwitchProfileDto } from '../models/SwitchProfileDto';
import type { TokenResponse } from '../models/TokenResponse';
import type { UserProfileSummary } from '../models/UserProfileSummary';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AuthService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Authenticate with Firebase
     * Verify a Firebase ID token, create or update the local user, and issue API JWT tokens. Returns isNewUser flag to indicate if the client should complete their profile. For Pro App users (AGENT/SOCIETY_OWNER), also returns available profiles.
     * @returns AuthResponse Authentication successful. Returns API JWT tokens and user data.
     * @throws ApiError
     */
    public authControllerAuthenticateWithFirebase({
        requestBody,
    }: {
        requestBody: FirebaseTokenDto,
    }): CancelablePromise<AuthResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/auth/firebase',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Firebase token does not contain required data (e.g. email).`,
                401: `Invalid Firebase ID token.`,
            },
        });
    }
    /**
     * Refresh API tokens
     * Rotate the refresh token. Provide a valid refresh token to get a new access token and refresh token pair.
     * @returns TokenResponse Tokens refreshed successfully.
     * @throws ApiError
     */
    public authControllerRefreshToken({
        requestBody,
    }: {
        requestBody: RefreshTokenDto,
    }): CancelablePromise<TokenResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/auth/refresh',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid or expired refresh token.`,
            },
        });
    }
    /**
     * Complete user profile
     * First-time profile setup after Firebase authentication. Choose a role and fill in profile data. Creates the corresponding role-specific profile record. For SOCIETY_OWNER, also creates a UserProfile entry. Idempotent: if the profile is already completed, it updates the existing data instead of throwing an error.
     * @returns CompleteProfileResponse Profile completed successfully. Returns new JWT tokens with updated role.
     * @throws ApiError
     */
    public authControllerCompleteProfile({
        requestBody,
    }: {
        requestBody: CompleteProfileDto,
    }): CancelablePromise<CompleteProfileResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/auth/complete-profile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized. Bearer token required.`,
                404: `User not found.`,
                409: `Phone number already associated with another account.`,
            },
        });
    }
    /**
     * List user profiles
     * Returns all UserProfile entries for the authenticated user. Used by the Pro App to show available profile contexts.
     * @returns UserProfileSummary List of user profiles.
     * @throws ApiError
     */
    public authControllerListProfiles(): CancelablePromise<Array<UserProfileSummary>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/auth/profiles',
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * Create a new profile
     * Allows a Pro App user to create an additional profile for a different role/society combination. Requires AGENT or SOCIETY_OWNER role.
     * @returns UserProfileSummary Profile created successfully.
     * @throws ApiError
     */
    public authControllerCreateProfile({
        requestBody,
    }: {
        requestBody: CreateProfileDto,
    }): CancelablePromise<UserProfileSummary> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/auth/profiles',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                409: `Profile already exists.`,
            },
        });
    }
    /**
     * Switch active profile
     * Exchange the current JWT for a new one scoped to the given profile. The new token includes profileId, profileRole, and societyId claims. Validates that the profile belongs to the user and the associated society exists.
     * @returns any Profile switched successfully. Returns new JWT tokens.
     * @throws ApiError
     */
    public authControllerSwitchProfile({
        requestBody,
    }: {
        requestBody: SwitchProfileDto,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/auth/switch-profile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                404: `Profile not found.`,
            },
        });
    }
}
